import {
  WiseOwlBlock,
  WiseOwlBlockType,
  WiseOwlBlockDisplayType,
  wiseOwlViewCopy,
} from '@twiliointernal/org/twilio/e2-commons/shared/definitions';
import { WiseOwlLoadingConfiguration } from '@twiliointernal/org/twilio/wise-owl/shared/ui';

const LOG_PREFIX = '[WiseOwlView]';

/**
 * These exact prompts are subject to change, and the way we
 * determine these prompts will change post-MLP, where they'll no longer be static
 * consider this temporary.
 */
const recommendedPrompts: WiseOwlBlock[] = [
  {
    type: WiseOwlBlockType.PromptSuggestionGroup,
    display: WiseOwlBlockDisplayType.Persistent,
    values: {
      categories: [
        {
          name: wiseOwlViewCopy.defaultPromptSuggestions.startingWithTwilio
            .name,
          suggestions: [
            wiseOwlViewCopy.defaultPromptSuggestions.startingWithTwilio
              .suggestions.first,
            wiseOwlViewCopy.defaultPromptSuggestions.startingWithTwilio
              .suggestions.second,
            wiseOwlViewCopy.defaultPromptSuggestions.startingWithTwilio
              .suggestions.third,
          ],
        },
        {
          name: wiseOwlViewCopy.defaultPromptSuggestions.accountHelp.name,
          suggestions: [
            wiseOwlViewCopy.defaultPromptSuggestions.accountHelp.suggestions
              .first,
            wiseOwlViewCopy.defaultPromptSuggestions.accountHelp.suggestions
              .second,
            wiseOwlViewCopy.defaultPromptSuggestions.accountHelp.suggestions
              .third,
          ],
        },
      ],
    },
  },
];

const preChat = {
  // link to quick start guide
  href: 'https://help.twilio.com/articles/18133722687643',
  recommendedPrompts,
};

const defaultLoadingState: WiseOwlLoadingConfiguration = {
  submission: false,
  preChat: false,
  fetchChatById: false,
};

const WISEOWL_CHAT_HEIGHT = '70vh';
const WISEOWL_CHAT_MIN_HEIGHT = '625px';

export {
  WISEOWL_CHAT_HEIGHT,
  WISEOWL_CHAT_MIN_HEIGHT,
  LOG_PREFIX,
  defaultLoadingState,
  preChat,
};
